function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_24x24_color",
  "data-name": "24x24 color"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,1H7a1,1,0,0,0-.99994,1V7L16,12l4,1.5L24,12V7Z",
  fill: "#21a366"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6.00004,
  y: 7.02084,
  width: 9.99995,
  height: 4.97916,
  fill: "#107c41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,2V7H16V1h7A1.003,1.003,0,0,1,24,2Z",
  fill: "#33c481"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,12H6V22a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V17Z",
  fill: "#185c37"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.83331,6H6V19.99993h7.60417a1.5,1.5,0,0,0,1.39577-1.3541V7.16668A1.17009,1.17009,0,0,0,13.83331,6Z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Back_Plate",
  "data-name": "Back Plate",
  x: 0.00004,
  y: 5.00001,
  width: 13.99996,
  height: 13.99993,
  rx: 1.16666,
  ry: 1.16666,
  fill: "#107c41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.4268,16l2.58856-4.01117L3.64437,8h1.908l1.29428,2.5495q.17844.3628.24547.54115h.01674q.12822-.28992.26778-.56346L8.76013,8h1.75175L8.07952,11.9665,10.57324,16H8.70992L7.2148,13.19941a2.338,2.338,0,0,1-.17852-.37378H7.014a1.76535,1.76535,0,0,1-.17295.36263L5.30128,16Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 11.99998,
  width: 7.99998,
  height: 5.00001,
  fill: "#107c41"
}));

function SvgExcel48X1(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32_24_20_16_px_12-06-2018") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel48X1);
export default __webpack_public_path__ + "static/media/excel_48x1.2afa894c.svg";
export { ForwardRef as ReactComponent };